<template>
    <v-col 
        cols="12"
        offset="0"
        lg="10"
        offset-lg="1"
        xl="12"
        offset-xl="0"
    >
        <v-row class="justify-center">
            <v-col 
                v-for="member in team" 
                :key="member.name"
                :cols="getColDistribution()"
            >
                <v-card
                    class="pt-4 px-4 medium-card team-card text-center bg-alpha-white"
                    height="100%"
                >
                    <WebPImage 
                        :aspect-ratio="1" 
                        :src-without-file-type="member.image" 
                        :available-file-types="member.imageTypes"
                        :max-height="computedMaxHeight(member.maxHeight)"
                        contain
                        no-auto-sizing
                    />
                    <v-card-title class="team-card-title pb-0">
                        {{ member.name }}
                    </v-card-title>
                    <v-card-title class="team-card-position pt-1">
                        {{ member.position }}
                    </v-card-title>
                    <v-card-text class="text-justify">
                        {{ member.intro }}
                    </v-card-text>
                    <div
                        v-if="member.socials"
                        class="d-flex flex-column socials"
                    >
                        <v-divider />
                        <div class="pt-2">
                            <v-btn
                                v-for="btn in member.socials"
                                :key="btn.icon"
                                :text="btn.type === 'text'"
                                :icon="btn.type === 'icon'"
                                plain
                                :href="btn.url"
                                target="_blank"
                                elevation="0"
                            >
                                <template v-if="btn.type === 'text'">
                                    {{ btn.title }}
                                </template>
                                <v-icon v-if="btn.type === 'icon'">
                                    {{ btn.icon }}
                                </v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import WebPImage from "@/components/WebPImage.vue";

export default {
    components: {
        WebPImage
    },
    data: () => ({
        supportsWebp: true,
        team: [
            {
                name: "Ali",
                image: "team/ali_1x1",
                imageTypes: ["webp", "jpg"],
                maxHeight: 300,
                intro: `Ich bin Ali und ich bin 25 Jahre alt. Als Teilnehmer von Aktion Zukunft 2016 und Teamer im Jahr 2018 hat mir Aktion Zukunft dabei geholfen, mich sprachlich und organisatorisch weiterzuentwickeln. Ich freue mich sehr auf das nächste Aktion Zukunft mit unserem voll motivierten Team und tollen Teilnehmer*innen.`,
                socials: [
                    {
                        type: "text",
                        title: "aaldaas@one-future.de",
                        url: "mailto://aaldaas@one-future.de"
                    }
                ]
            },
            {
                name: "Gina",
                image: "team/gina_1x1",
                imageTypes: ["webp", "jpg"],
                maxHeight: 300,
                intro: `Ich bin Gina und ich bin 23 Jahre alt. Aktion Zukunft ist schon lange ein Teil von mir. Bereits 2016 habe ich als Teilnehmerin von Aktion Zukunft das Projekt kennengelernt und dann 2018 als Organisatorin des Seminars mitgewirkt. Nun bin ich im Vorstand von One Future e.V. und unglaublich froh darüber, dass ich nun wieder die Chance bekomme, Aktion Zukunft mitgestalten zu können.`,
                socials: [
                    {
                        type: "text",
                        title: "gkriesmann@one-future.de",
                        url: "mailto://gkriesmann@one-future.de"
                    }
                ]
            },
            {
                name: "Joshua",
                image: "team/joshua_1x1",
                imageTypes: ["webp", "jpg"],
                maxHeight: 300,
                intro: `Ich bin Joshua und ich bin 25 Jahre alt. Als Mitbegründer und Vorsitzender von One Future e.V. habe ich Aktion Zukunft 2016 und 2018 organisiert. Nachdem ich bereits viele tolle Projekte von den Alumni*ae mitbegleitet habe, bin ich gespannt auf unsere neuen Teilnehmer*innen, ihren Enthusiasmus und Impulse für die Gesellschaft. `,
                socials: [
                    {
                        type: "text",
                        title: "jkriesmann@one-future.de",
                        url: "mailto://jkriesmann@one-future.de"
                    }
                ]
            }
        ]
    }),
    mounted() {
        var img = new Image();
        img.onload = function() {
            this.supportsWebp = !!(img.height > 0 && img.width > 0);
        };
        img.onerror = function() {
            this.supportsWebp = false;
        };
        img.src = require("@/assets/img/webp_check.webp");
    },
    methods: {
        getImageSource(object) {
            let src;

            if(this.supportsWebp) {
                src = object.image + ".webp";
            } else {
                src = object.image + ".jpg";
            }

            console.log(src);

            return require("@/assets/img/team/" + src);
        },
        
        getColDistribution() {
            let cols = 12;

            if(this.$vuetify.breakpoint.smAndUp) {
                cols = 6;
            }
            if(this.$vuetify.breakpoint.mdAndUp) {
                cols = 6;
            }
            if(this.$vuetify.breakpoint.lgAndUp) {
                cols = 4;
            }
            if(this.$vuetify.breakpoint.xlOnly) {
                cols = "undefined";
            }

            return cols;
        },

        computedMaxHeight(baseHeight) {
            if(this.$vuetify.breakpoint.xsOnly) {
                return Math.floor(baseHeight * 0.75);
            }

            return baseHeight;
        }
    }
}
</script>

<style lang="scss">
$team-card-padding: 3rem;

.team-card {
  padding-bottom: 53px !important;

  .socials {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 8px;
  }
}

.team-card-title {
  font-weight: 400;
  font-size: 1.5rem;
  justify-content: center;
}

.team-card-position {
  font-family: "Roboto";
  font-weight: 300;
  font-size: 1rem;
  color: grey;
  justify-content: center;
  text-transform: uppercase;
}
</style>